<template>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col>
          <v-toolbar v-if="!reference" dense flat color="transparent">
            <v-icon left color="primary">mdi-cash</v-icon>
            <v-toolbar-title class="primary--text">Gastos</v-toolbar-title>
            <v-divider v-if="!reference" class="primary mx-7"></v-divider>
          </v-toolbar>
          <v-data-table
            :loading="loadingData"
            id="orderTable"
            dense
            @click:row="openOrderDetail"
            :headers="orderHeaders"
            :items="items"
            :options.sync="options"
            :server-items-length="total"
            :footer-props="{ 'items-per-page-options': [20, 50, 100] }"
            class="elevation-0 no-wrap-table mt-5 row-pointer">
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-dialog v-model="orderDetail" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark class="elevation-0 secondary">
          <v-toolbar-title> <strong>{{ orderName }}</strong></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          <v-btn icon dark @click="orderDetail = false">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <OrderDetail :_id="orderID"/>
      </v-card>
    </v-dialog>
    <v-navigation-drawer right v-model="drawerRight" fixed temporary width="400" app>
      <v-toolbar dark class="elevation-0 secondary">
        <v-toolbar-title> <strong>Filtros y busquedas</strong></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon>mdi-filter-cog</v-icon>
      </v-toolbar>
      <v-container>
        <v-row>
          <v-col class="pb-0">
            <v-subheader class="secondary--text" style="height: auto;">Tipo de reserva</v-subheader>
            <v-select :loading="loading" prepend-icon="mdi-ghost-outline" v-model="isVirtual" :items="types" hide-details dense placeholder="Todas"></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-subheader class="secondary--text" style="height: auto;">Tienda</v-subheader>
            <v-autocomplete :loading="loading" @update:search-input="onSearchBusiness" prepend-icon="mdi-store" v-model="business" :items="businessArray" persistent-hint :persistent-placeholder="true" hide-details dense placeholder="Restaurante" multiple clearable chips deletable-chips small-chips></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-subheader class="secondary--text" style="height: auto;">
              Fecha de creacion
              <v-spacer></v-spacer>
              <span>
                <v-checkbox :loading="loading" small v-model="createdAtRange" :label="`Rango`" hide-details dense></v-checkbox>
              </span>
            </v-subheader>
            <v-dialog ref="modalCreatedAt" v-model="modalCreatedAt" :return-value.sync="createdAt" persistent width="290px">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field :loading="loading" prepend-icon="mdi-calendar-badge" v-model="createdAt" readonly v-bind="attrs" v-on="on" hide-details dense clearable :placeholder="`${createdAtRange ? '26/09/2024 ~ 01/12/2024' : '26/09/2024' }`"></v-text-field>
              </template>
              <v-date-picker v-if="!createdAtRange" v-model="createdAt" @input="$refs.modalCreatedAt.save(createdAt)"></v-date-picker>
              <v-date-picker v-else v-model="createdAt" range>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modalCreatedAt = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.modalCreatedAt.save(createdAt)">Aceptar</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style="height: 64px;"></div>
          </v-col>
        </v-row>
        <v-footer fixed padless>
          <v-row>
            <v-col class="text-center" cols="12" >
              <v-toolbar  class="elevation-0" color="grey lighten-5">
                <v-btn @click="getOrders" class="elevation-0 primary--text" text>Aplicar</v-btn>
                <v-spacer></v-spacer>
                <v-btn class="elevation-0" text>Limpiar</v-btn>
              </v-toolbar>
            </v-col>
          </v-row>
        </v-footer>
      </v-container>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import OrderDetail from '@/components/booking/balance/OrderDetail.vue'
import BookingDetail from '@/components/booking/BookingDetail.vue'
import { setCurrencyFormat } from '@/utils/index'
import moment from 'moment'
import api from '@/api/order'
import apiBusiness from '@/api/business'
import { orderHeaders } from '@/constants/tableheaders'
export default {
  components: { OrderDetail, BookingDetail },
  data: () => ({
    loading: false,
    drawerRight: false,
    loadingData: true,
    orderHeaders,
    items: [],
    options: {},
    total: 0,
    orderName: '',
    createdAt: null,
    modalCreatedAt: false,
    createdAtRange: false,
    orderDetail: false,
    isVirtual: null,
    orderID: null,
    types: [
      { text: 'Todas', value: null },
      { text: 'Reales', value: false },
      { text: 'Virtuales', value: true },
    ],
    business: null,
    businessArray: [],
  }),
  props: {
    reference: String,
  },
  mounted() {
    this.getBusiness()
    this.getOrders()
  },
  methods: {
    async getOrders() {
      try {
        this.loadingData = true
        console.log('this.orderOptions', this.options)
        const query = {
          ...this.options,
          isVirtual: this.isVirtual,
          business: this.business,
          createdAt: this.createdAtRange 
            ? this.createdAt ? [moment(this.createdAt[0]).format('YYYY-MM-DD'), moment(this.createdAt[1]).format('YYYY-MM-DD')] : null
            : this.createdAt ? moment(this.createdAt).format('YYYY-MM-DD') : null,
        }
        const { data: { data: orders, total } } = await api.getOrdersByRef(this.reference, query)
        this.items = orders.map(item => this.formatDataTable(item))
        this.total = total
        console.log('data ', orders)
        console.log('total ', total)
        this.loadingData = false
      } catch (error) {
        this.loadingData = false
        console.log('error', error)
        this.$notify({ type: 'error', group: 'noti', title: 'Error con comunicacion con el servidor.', text: 'No se pudo establecer comunicacion con servidor.' })
      }
    },
    formatDataTable(item) {
      item.createdAt = moment.utc(item.createdAt).format('DD/MM/YYYY')
      item.subtotal = setCurrencyFormat(item.subtotal)
      item.total = setCurrencyFormat(item.total)
      item.isVirtual = item.isVirtual ? 'SI' : 'NO'
      item.employee = item.employee ? `${item.employee.name.split(' ')[0]} ${item.employee.lastName.split(' ')[0]}` : ''
      return item
    },
    openDrawer() {
      this.drawerRight = true
    },
    openOrderDetail(row) {
      console.log('clicked row', row)
      this.orderName = row.name
      this.orderID = row._id
      this.orderDetail = true
    },
    async getBusiness() {
      try {
        this.loading = true
        const { data: { data: business } } = await apiBusiness.table({ itemsPerPage: 10, page: 1 })
        // console.log('business', business)
        this.businessArray = business.map(v => ({ text: v.name, value: v._id }))
        this.loading = false
      } catch (error) {
        this.loadingData = false
        console.log('error', error)
        this.$notify({ type: 'error', group: 'noti', title: 'Error con comunicacion con el servidor.', text: 'No se pudo establecer comunicacion con servidor.' })
      }
    },
    onSearchBusiness(search) {
      console.log('search', search)
    },
    async getAllItems() {
      try {
        this.loadingData = true
        const query = {
          isVirtual: this.isVirtual,
          business: this.business,
          createdAt: this.createdAtRange 
            ? this.createdAt ? [moment(this.createdAt[0]).format('YYYY-MM-DD'), moment(this.createdAt[1]).format('YYYY-MM-DD')] : null
            : this.createdAt ? moment(this.createdAt).format('YYYY-MM-DD') : null,
        }
        const { data: { data: orders } } = await api.getOrdersByRef(this.reference, query)
        this.loadingData = false
        return orders.map(item => this.formatDataTable(item))
      } catch (error) {
        this.loadingData = false
        console.log('error', error)
        this.$notify({ type: 'error', group: 'noti', title: 'Error con comunicacion con el servidor.', text: 'No se pudo establecer comunicacion con servidor.' })
      }
    },
  },
  watch: {
    reference() {
      this.getOrders()
    },
    options: {
      deep: true,
      handler() {
        this.getOrders()
      },
    },
    createdAtRange() {
      this.createdAt = null
    },
  },
}
</script>